import { app } from '../../../../../../../app';
import { Controller } from './user-settings-confirm.controller';

app.component('companyUserDirectoriesSaaspassUsersUserSettingsConfirm', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./user-settings-confirm.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/all-users/user-settings/confirm/user-settings-confirm.component.js